import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";


export const newsletterCampaignApi = createApi({
    reducerPath: "newsletterCampaignApi",
    baseQuery: baseQueryWithReauth,
    tagTypes: ["NewsletterCampaign"],
    endpoints: (builder) => ({
        // Get all newsletter campaigns
        getAllNewsletterCampaigns: builder.query({
            query: () => "/newsletter-campaigns",
            providesTags: ["NewsletterCampaign"],
            transformResponse: (response) => {
                // Map _id to id for frontend compatibility
                if (response.data && Array.isArray(response.data)) {
                    return {
                        ...response,
                        data: response.data.map(item => ({
                            ...item,
                            id: item._id
                        }))
                    };
                }
                return response;
            },
        }),

        // Get newsletter campaign by ID
        getNewsletterCampaignById: builder.query({
            query: (id) => `/newsletter-campaigns/${id}`,
            providesTags: (result, error, id) => [{ type: "NewsletterCampaign", id }],
        }),

        // Get newsletter stats
        getNewsletterStats: builder.query({
            query: () => "/newsletter-campaigns/stats",
            providesTags: ["NewsletterCampaign"],
        }),

        // Create newsletter campaign
        createNewsletterCampaign: builder.mutation({
            query: (newsletterData) => ({
                url: "/newsletter-campaigns",
                method: "POST",
                body: newsletterData,
            }),
            invalidatesTags: ["NewsletterCampaign"],
        }),

        // Update newsletter campaign
        updateNewsletterCampaign: builder.mutation({
            query: ({ id, ...newsletterData }) => ({
                url: `/newsletter-campaigns/${id}`,
                method: "PUT",
                body: newsletterData,
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: "NewsletterCampaign", id },
                "NewsletterCampaign",
            ],
        }),

        // Delete newsletter campaign
        deleteNewsletterCampaign: builder.mutation({
            query: (id) => ({
                url: `/newsletter-campaigns/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["NewsletterCampaign"],
        }),
    }),
});

export const {
    useGetAllNewsletterCampaignsQuery,
    useGetNewsletterCampaignByIdQuery,
    useGetNewsletterStatsQuery,
    useCreateNewsletterCampaignMutation,
    useUpdateNewsletterCampaignMutation,
    useDeleteNewsletterCampaignMutation,
} = newsletterCampaignApi;
